import images from './images';

export const menuCategories = [
  {
    id: 'sushi',
    title: 'Sushi',
    images: [images.sushi, images.sushi2],
  },

  {
    id: 'salads & light-meals',
    title: 'Starters, Salads & Light Meals',
    images: [images.salads_and_light_meals],
  },

  {
    id: 'grills',
    title: 'Grills & Traditional',
    images: [images.grills],
  },

  {
    id: 'sea-food & More',
    title: 'Sea Food & More From The Kitchen',
    images: [images.traditional_and_sea_food],
  },

  {
    id: 'Desserts',
    title: 'Desserts',
    images: [images.More_from_the_Kitchen],
  },
  {
    id: 'cocktails',
    title: 'Cocktails',
    images: [images.Cocktails],
  },
  {
    id: 'mocktails smoothies & milkshakes',
    title: 'Mocktails, Smoothies & Milkshakes',
    images: [images.Milkshakes_and_Smoothies],
  },
  {
    id: 'wine list',
    title: 'Wine List',
    images: [
      images.Wine_List1,
      images.Wine_List2,
      images.Wine_List3,
      images.Wine_List4,
      images.Wine_List5,
      images.Wine_List6,
      images.Wine_List7,
    ],
  },
];
